/* app/js/src/components/clipping-studio/panels/destination-tab/tiktok-publish-settings/clipping-studio-tiktok-publish-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.tiktok-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.tiktok-settings__actions {
  display: flex;
  justify-content: flex-end;
}
.tiktok-settings__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.tiktok-settings__reset {
  border: 0;
  background: transparent;
  color: rgb(45, 187, 252);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.tiktok-settings__reset:disabled {
  color: rgba(0, 0, 0, 0.35);
  cursor: not-allowed;
}
.tiktok-settings__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.tiktok-settings__dropdown {
  width: 100%;
}
.tiktok-settings__dropdown--invalid ::ng-deep .selected-container {
  border-color: #ef5350;
}
.tiktok-settings__checkbox {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
  --mdc-checkbox-selected-checkmark-color: rgb(255, 255, 255);
  --mdc-checkbox-selected-focus-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-hover-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-pressed-icon-color: rgb(45, 187, 252);
}
.tiktok-settings__checkbox ::ng-deep .mdc-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
}
.tiktok-settings__checkbox ::ng-deep .mdc-checkbox__ripple,
.tiktok-settings__checkbox ::ng-deep .mat-mdc-checkbox-ripple,
.tiktok-settings__checkbox ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
.tiktok-settings__checkbox.mat-mdc-checkbox-disabled {
  cursor: not-allowed;
}
.tiktok-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-label {
  color: rgba(0, 0, 0, 0.35);
}
.tiktok-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-checkbox__background {
  border-color: rgb(194, 204, 219) !important;
  background-color: rgb(235, 240, 244) !important;
}
.tiktok-settings__checkbox--strong {
  font-weight: 700;
}
.tiktok-settings__checkbox--strong ::ng-deep .mdc-label {
  font-weight: 700;
}
.tiktok-settings__nested {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 20px;
}
.tiktok-settings__helper {
  margin: 0;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.4;
}
.tiktok-settings__helper--aigc {
  max-width: 220px;
  margin-left: 28px;
}
.tiktok-settings__error {
  padding: 12px 0;
}
.tiktok-settings__error-text,
.tiktok-settings__field-error {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.tiktok-settings__field-error {
  font-size: 12px;
  line-height: 1.35;
}
/*# sourceMappingURL=clipping-studio-tiktok-publish-settings.component.css.map */
